export enum TestResult {
  skipped = 0,
  success = 1,
  fail = 2,
  crashed = 3,
}